import type { Pattern } from "../types.js";

/**
 * REAL CONTENT — eneatipo 5. Portado de
 * `docs/canonical/Plantilla_maestra_nueve_eneatipos.docx`, Bloques A, B, D y E.
 *
 * En inglés, con el original español al lado de cada campo, igual que los
 * patrones 1, 6 y 9.
 *
 * Las marcas del canon se conservan: [PROPUESTA] es formulación del proyecto,
 * [LÍMITE] es un riesgo declarado, [FUENTE PROYECTO] viene de Vilaseca. Que
 * `shortHypothesis` sea [PROPUESTA] y no fuente externa importa: es la frase
 * que la persona lee como resultado.
 *
 * PARES: el Bloque E del 5 trata el 4 y el 6. El 5↔9 sale del lado del 9.
 */
export const PATTERN_5: Pattern = {
  id: "5",
  number: 5,
  // «el analista» — Vilaseca: «el observador»
  workingName: "The observer (working name)",
  // Patrón organizado alrededor de retirarse y acumular conocimiento para sentirse preparado/a antes de actuar o exponerse
  shortHypothesis:
    "A pattern organised around withdrawing and gathering knowledge in order " +
    "to feel prepared before acting or being exposed.",
  // Aislamiento, dificultad para el compromiso emocional, tendencia a teorizar en vez de actuar
  whatItExplains:
    "Isolation, difficulty with emotional commitment, and a tendency to " +
    "theorise instead of acting.",
  // El contenido concreto de qué considera cada persona suficiente preparación; el origen de un interés intelectual concreto
  whatItDoesNotExplain:
    "What any given person counts as enough preparation, or where a specific " +
    "intellectual interest came from.",
  // [LÍMITE] Que la persona se defina como «la fría de siempre» y use la etiqueta para justificar el aislamiento permanente
  identityRisk:
    "Defining yourself as \u201cthe cold one\u201d and using the label to justify " +
    "permanent isolation.",
  confusablePatterns: ["4", "6", "9"],
  sourceRefs: [
    "Plantilla_maestra_nueve_eneatipos.docx, Eneatipo 5, Bloques A, B, D y E",
    "[LÍMITE] Vilaseca-céntrico: sin triangular contra una segunda fuente"
  ],
  contentVersion: "canon-nueve-1.0"
};
